import { useSetAtom } from "jotai";
import { v4 as uuid } from "uuid";

import { toastsAtom } from "./atoms";
import { TOAST_DEFAULT_DURATION, TOAST_DEFAULT_TYPE } from "./constants";
import { Toast, ToastAction, ToastDuration, ToastType } from "./types";
import { extractToastError, resolveToastMessage } from "./utils";

export const useToasts = () => {
  const setToasts = useSetAtom(toastsAtom);

  const toast = (toast: {
    title: string;
    message?: string;
    error?: unknown;
    duration?: ToastDuration;
    type?: ToastType;
    actions?: ToastAction[];
  }) => {
    const extractedError = extractToastError({
      error: toast.error,
      type: toast.type,
      message: toast.message,
    });

    if (extractedError !== null) {
      console.warn(`${toast.title}:`, extractedError);
    }

    const id = uuid();
    const message = resolveToastMessage(toast.error, extractedError, toast.message);

    setToasts((toasts) => [
      ...toasts,
      {
        id,
        title: toast.title,
        message,
        duration: toast.duration || (extractedError !== null && 60_000) || TOAST_DEFAULT_DURATION,
        type: toast.type || (extractedError !== null && "ERROR") || TOAST_DEFAULT_TYPE,
        state: "OPEN",
        actions: toast.actions || [],
      },
    ]);

    return id;
  };

  const closeToast = (id: string) => {
    setToasts((toasts) => {
      return toasts.map<Toast>((toast) => {
        if (toast.id === id && toast.state === "OPEN") {
          return { ...toast, state: "CLOSE" };
        }

        return toast;
      });
    });
  };

  return { toast, closeToast };
};
